(function fileModuleDefinition() {
    'use strict';

    angular.module('File', ['ui.router', 'Config', 'Entities', 'ErrorsExtend', 'dndLists', 'EmbedSrcAttr', 'DocumentViewer'])
        .config([
            'configProvider', '$stateProvider', 'loginProvider',
            function fileConfig(config, $stateProvider, loginProvider) {
                $stateProvider.state('file-detail', {
                    url: '/File/Get/{id}',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDetailController',
                    authorize: true
                });

                $stateProvider.state('file-document-detail', {
                    url: '/Document/{id}/Version/{version}/files',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDocumentDetailController',
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    authorize: true
                });

                $stateProvider.state('myfile-document-detail', {
                    url: '/MyDocument/{id}/Version/{version}/files',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDocumentDetailController',
                    resolve: {
                        myDocument: function () {
                            return true;
                        }
                    },
                    authorize: true
                });

                $stateProvider.state('file-document-detail-one', {
                    url: '/Document/{id}/Version/{version}/files/{file}',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDocumentDetailController',
                    resolve: {
                        myDocument: function () {
                            return false;
                        }
                    },
                    authorize: true
                });

                $stateProvider.state('myfile-document-detail-one', {
                    url: '/MyDocument/{id}/Version/{version}/files/{file}',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDocumentDetailController',
                    resolve: {
                        myDocument: function () {
                            return true;
                        }
                    },
                    authorize: true
                });

                $stateProvider.state('file-document-sign', {
                    url: '/Document/{id}/Version/{version}/Sign/{file}',
                    templateUrl: config.resourceUrl('/views/file/sign.html'),
                    controller: 'FileDocumentSignController',
                    authorize: true,
                    roles: loginProvider.roleCondition('DOCUMENT SIGN').or('DOCUMENTVERSION SIGN')
                });

                $stateProvider.state('file-document-container-detail', {
                    url: '/DocumentContainer/{id}/files',
                    templateUrl: config.resourceUrl('/views/file/detail.html'),
                    controller: 'FileDocumentContainerDetailController',                   
                    authorize: true
                });
            }
        ]);
})();